const initHeroSearch = () => {
  const heroSearch = document.getElementsByClassName('js-hero-search')[0]

  if (heroSearch) {
    const searchButton = heroSearch.getElementsByClassName(
      'js-hero-search__submit-btn',
    )[0]
    const searchDropdown = heroSearch.getElementsByClassName(
      'js-hero-search__dropdown',
    )[0]
    const selectedChoice = searchDropdown.getElementsByClassName(
      'js-hero-search__selected',
    )[0]
    const searchChoices = searchDropdown.getElementsByClassName(
      'js-hero-search__choice',
    )

    // Add an event listener to the window for clicks inside and outside the search box
    window.addEventListener('click', function (e) {
      if (searchDropdown.contains(e.target)) {
        // Clicked inside
        searchDropdown.classList.toggle('c-hero-search__dropdown--active')
      } else {
        // Clicked outside the box
        searchDropdown.classList.remove('c-hero-search__dropdown--active')
      }
    })

    for (let i = 0; i < searchChoices.length; i++) {
      const element = searchChoices[i]

      element.addEventListener('click', function (e) {
        const label = e?.target?.innerHTML
        const location = e?.target?.dataset?.location

        if (label) {
          // Update dropdown label
          selectedChoice.innerHTML = label
        }
        if (location) {
          const target = e?.target?.dataset?.target
            ? e?.target?.dataset?.target
            : '_self'

          console.log(target)

          // Update button href (because safari remembers state when the user goes back)
          searchButton.href = location

          // Redirect to the chosen page (in a new tab, or the current if that is blocked)
          window.open(location, target) || window.location.replace(location)
        }
      })
    }
  }
}

export default initHeroSearch
